import styles from "@components/ExpertInitialAvatar.module.css";

type Size = "default" | "large" | "small" | "tiny";

type Props = {
  className?: string;
  expert: {
    firstName: string;
    lastName: string;
  };
  size?: Size;
  title?: string;
};

const ExpertInitialAvatar = ({ className, expert, size = "default", title }: Props) => {
  const useClassName = (className ?? styles[size]) + " " + styles.avatar;

  return (
    <div className={useClassName} data-test="client-avatar" title={title}>
      {expert.firstName[0] + expert.lastName[0]}
    </div>
  );
};
export default ExpertInitialAvatar;
